const COLORS = {
  primary: "#108236",
  black: "#1E1E1C",
  secondGreen: "#B6C69A",
  green: "#4CAF50",
  blue: "#2196F3",
  violet: "#9C27B0",
  yellow: "#FFC107",
};
export default COLORS;

export const STATUS_COLORS = {
  DISPONIBLE: COLORS?.blue,
  ASSIGNEE: COLORS?.green,
  ASSIGNE: COLORS?.green,
  DEFECTUEUX: "#F44336",
  RETIREE: COLORS?.yellow,
  RETIRE: COLORS?.yellow,
  EN_ATTENTE: COLORS?.blue,
  EN_COURS: COLORS?.yellow,
  CLOTURE: COLORS?.green,
  ANNULE: "#F44336",
  ECHEC: "#F44336",
  SUCCES: COLORS?.green,
  INITIALIZED: COLORS?.blue,
};

export const STATUS_LABEL_COLORS = {
  PLANIFIEE: { color: COLORS?.blue, label: "Planifié" },
  EN_COURS: { color: COLORS?.yellow, label: "En cours" },
  TERMINEE: { color: COLORS?.green, label: "Terminé" },
  SUSPENDUE: { color: "#854d0e", label: "Suspendu" },
  ANNULEE: { color: "#b91c1c", label: "Annulée" },
  DISPONIBLE: { color: COLORS?.blue, label: "Disponible" },
  ASSIGNE: { color: COLORS?.green, label: "Assignée" },
  DEFECTUEUX: { color: "#F44336", label: "Défectueux" },
  RETIREE: { color: COLORS?.yellow, label: "Retirée" },
  EN_ATTENTE: { color: COLORS?.blue, label: "En attente" },
  CLOTURE: { color: COLORS?.green, label: "Clôturé" },
  ANNULE: { color: "#F44336", label: "Annulé" },
  ECHEC: { color: "#F44336", label: "Échec" },
  SUCCES: { color: COLORS?.green, label: "Succès" },
  INITIALIZED: { color: COLORS?.blue, label: "Initialisé" },
  VIVANT: { color: COLORS?.green, label: "Vivant" },
  MORT: { color: "#F44336", label: "Mort" },
  MORT_NE: { color: "#F44336", label: "Mort-né" },
  AVORTEMENT: { color: COLORS.violet, label: "Avortement" },
  MORT_APRES_NAISSANCE: {
    color: "#6b7280",
    label: "Mort après naissance",
  },
  AUTORITE: { color: COLORS?.green, label: "Autorité" },
  ACTIVE: { color: COLORS?.green, label: "Activé" },
  TRANSHUMANT: { color: COLORS.violet, label: "Transhumant" },
  DRAFT: { color: "#6b7280", label: "Brouillon" },
  SUBMITTED: { color: COLORS?.blue, label: "Soumise" },
  IN_REVIEW: { color: "#FFC107", label: "En cours de revue" },
  APPROVED: { color: "#4CAF50", label: "Approuvée" },
  REJECTED: { color: "#F44336", label: "Rejetée" },
  CLOSED: { color: "#374151", label: "Clôturée" },
};
